
import Vue from 'vue';
import axios from 'axios';
import TextInput from '@shared/components/TextInput.vue';
import TextArea from '@shared/components/TextArea.vue';
import CheckboxInput from '@shared/components/CheckboxInput.vue';
import SelectInput from '@shared/components/SelectInput.vue';

export default Vue.extend({
  name: 'contact-us',
  components: {
    TextInput,
    TextArea,
    CheckboxInput,
    SelectInput,
  },
  data() {
    return {
      customerType: process.env.VUE_APP_CUSTOMERTYPE as string,
      consentCheckbox: process.env.VUE_APP_CONSENT as string,
      newletterCheckbox: process.env.VUE_APP_NEWSLETTER as string,
      consent: false,
      newsletter: false,
      phone: false,
      email: false,
      showBusiness: false,
      companyTitle: '',
      isFormSentSuccess: false,
      errors: [''],
      form: {
        // eslint-disable-next-line @typescript-eslint/camelcase
        first_name: '',
        // eslint-disable-next-line @typescript-eslint/camelcase
        last_name: '',
        email: '',
        company: '',
        phonenumber: '',
        description: '',
        customerType: '',
      },
    };
  },
  computed: {
    isDevMode(): boolean {
      return process.env.VUE_APP_ENV === 'test';
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setCompany: function(evt: any) {
      switch (evt.target.value) {
        case 'B2B':
          this.companyTitle = 'Firma';
          this.showBusiness = true;
          break;
        case 'Apartment Complex':
          this.companyTitle = 'Borettslag';
          this.showBusiness = true;
          break;
        case 'Agriculture':
          this.companyTitle = 'Landbruk';
          this.showBusiness = true;
          break;
        default:
          // B2C
          this.companyTitle = '';
          this.showBusiness = false;
          break;
      }
      this.form.customerType = evt.target.value;
    },
    submitForm(e: Event) {
      if (this.checkForm(e)) {
        const http = axios.create({
          baseURL: process.env.VUE_APP_BACKEND_URL,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const a = {} as any;
        // eslint-disable-next-line @typescript-eslint/camelcase
        a.lead_source = "Web Solar 'Contact Us'";
        a[this.customerType] = this.form.customerType;
        a[this.consentCheckbox] = this.consent ? '1' : '0';
        a[this.newletterCheckbox] = this.newsletter ? '1' : '0';
        a['recordType'] = process.env.VUE_APP_RECORDTYPE as string;

        const postData = Object.assign(a, this.form); // Merge form data with salesforce ids

        let pd = '';
        Object.keys(postData).forEach(key => {
          if (pd.length > 1) {
            pd += '&';
          }
          pd += `${key}=${encodeURI(postData[key])}`;
        });

        // @ts-ignore
        this.$gtm.trackEvent({
          event: 'sendt_form',
          category: 'Solkraft',
          action: 'Fullført leadsskjema',
          label: this.form.customerType,
        });

        http
          .post('', pd)
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .then()
          .catch(err => console.log('err', err));

        this.isFormSentSuccess = true;
      }
    },
    checkForm: function(e: Event) {
      this.errors = [];

      if (!this.form.customerType || this.form.customerType === '') {
        this.errors.push('Mangler kundetype.');
      }

      if (!this.form.first_name) {
        this.errors.push('Mangler fornavn.');
      }
      if (!this.form.last_name) {
        this.errors.push('Mangler etternavn.');
      }
      if (
        this.showBusiness &&
        (!this.form.company || this.form.company.length < 1)
      ) {
        this.errors.push('Mangler Firma/Borettslag/Landbruk.');
      }
      if (!this.form.description) {
        this.errors.push('Mangler melding.');
      }

      if (!this.errors.length) {
        return true;
      }
      e.preventDefault();
    },
  },
});
